<template>
  <div class="button-row-container">
    <navigation-buttons
      :is-qot-d="isQotD"
      :show-previous="showPrevious"
      :disable-previous="disablePrevious"
      :show-next="shouldShowNext"
      :disable-next="disableNext"
      @previous-flashcard="$emit('previous-flashcard')"
      @next-flashcard="$emit('next-flashcard')"
    ></navigation-buttons>
    <div
      class="right-buttons"
    >
      <button
        class="submit-button"
        data-test="submit-button"
        :disabled="!canSubmitAnswer"
        @click="submitAnswer"
      >
        Submit
      </button>
    </div>
    <key-capture
      v-if="canSubmitAnswer"
      @keydown="handleKeyDown"
    ></key-capture>
  </div>
</template>

<script>
import NavigationButtons from './NavigationButtons.vue';
import KeyCapture from '@/components/singletons/KeyCapture.vue';
import CurrentFlashcardSessionMixin from '@/mixins/currentFlashcardSession';

export default {
  components: {
    NavigationButtons,
    KeyCapture,
  },
  mixins: [CurrentFlashcardSessionMixin],
  props: {
    canSubmitAnswer: {
      type: Boolean,
      default: false,
    },
    disableNext: {
      type: Boolean,
      default: false,
    },
    disablePrevious: {
      type: Boolean,
      default: false,
    },
    showNextOverride: {
      type: Boolean,
      default: null,
    },
  },
  emits: ['answer', 'previous-flashcard', 'next-flashcard'],
  computed: {
    shouldShowNext() {
      if (this.showNextOverride !== null) {
        return this.showNextOverride;
      }
      return this.showNext;
    },
  },
  methods: {
    handleKeyDown(key, event) {
      if (this.canSubmitAnswer && key === 'Enter' && event.shiftKey) {
        event.preventDefault();
        event.stopPropagation();
        this.submitAnswer();
      }
    },
    submitAnswer() {
      this.$emit('answer');
      this.$store.commit('ui/setShowAssetTray', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.button-row-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #F9FAFB;
  z-index: 10;
}

.submit-button {
  background-color: #155eef;
  color: white;
  height: rem-calc(48);
  font-weight: 600;
  font-size: rem-calc(18);
  padding-right: rem-calc(38);
  padding-left: rem-calc(38);
  border-radius: rem-calc(8);

  &:disabled {
    background-color: #B2CCFF;
  }
}

@include breakpoint(tablet) {
  .button-row-container {
    left: rem-calc(88);
    bottom: 0;
  }
}

@include breakpoint(desktop) {
  .button-row-container {
    left: rem-calc(88);
    bottom: 0;
    padding: 0rem 2rem 2rem;
  }
}
</style>
